import React from "react";
//@ts-ignore
import nuvoretailLogo from "./images/nuvoretail-logo.png";

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <img 
      src={nuvoretailLogo} 
      alt="NuvoRetail enlytical.ai" 
      className={className || "h-10"}
    />
  );
};
